<web-settings-body>
    @switch (currentSettings()) {
        @case (settingsEnum.Main) {
            <ng-container>
                <web-settings-breadcrumbs>
                    <div class="breadcrumb-icon">
                        <button
                            type="button"
                            [tooltip]="'site_styles' | translate"
                            placement="bottom"
                            [attr.aria-label]="'site_styles' | translate"
                            (click)="setSelectedTheme()"
                        >
                            <img
                                class="first-breadcrumb-icon"
                                src="./assets/img/websites/lpc-theme-settings-icon.svg"
                                alt=""
                            />
                        </button>
                        <img
                            src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                            class="breadcrumb-arrow-icon"
                            alt=""
                        />
                    </div>
                    <div class="breadcrumb-icon">
                        <button
                            type="button"
                            [tooltip]="'control_block' | translate"
                            placement="bottom"
                            [attr.aria-label]="'control_block' | translate"
                            (click)="setSelectedBlockObs()"
                        >
                            <img class="first-breadcrumb-icon" src="assets/img/websites/lpc-block-icon.svg" alt="" />
                        </button>
                        <img
                            src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                            class="breadcrumb-arrow-icon"
                            alt=""
                        />
                    </div>
                    <div class="breadcrumb-icon">
                        <button
                            type="button"
                            [tooltip]="'control_column' | translate"
                            placement="bottom"
                            [attr.aria-label]="'control_column' | translate"
                            (click)="setSelectedColumn(form.parentId())"
                        >
                            <img class="first-breadcrumb-icon" src="assets/img/websites/lpc-column-icon.svg" alt="" />
                        </button>
                        <img
                            src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                            class="breadcrumb-arrow-icon"
                            alt=""
                        />
                    </div>
                    <div class="breadcrumb-icon">
                        <img
                            src="./assets/img/websites/lpc-tab-icon.svg"
                            class="first-breadcrumb-icon"
                            alt="lpc-column-icon"
                        />
                    </div>
                    <div class="breadcrumb-text">
                        <span>{{ "Tab" | translate }}</span>
                    </div>
                </web-settings-breadcrumbs>

                <div class="panel-options-body overflow-wrapper" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
                    <form class="form-row form-horizontal" (submit)="$event.preventDefault()">
                        <div class="form-group row mb-20">
                            <div class="col-xs-12">
                                <label>
                                    {{ "control_appearance" | translate }}
                                </label>
                                <a
                                    class="dotted pull-right"
                                    role="button"
                                    tabindex="0"
                                    (click)="currentSettings.set(settingsEnum.Appearance)"
                                    (keydown.enter)="currentSettings.set(settingsEnum.Appearance)"
                                    (keydown.space)="
                                        $event.preventDefault(); currentSettings.set(settingsEnum.Appearance)
                                    "
                                >
                                    {{ "control_tab_styles" | translate }}
                                </a>
                            </div>
                            <div class="col-xs-12">
                                <div
                                    class="appearance-wrapper"
                                    role="group"
                                    [attr.aria-label]="'control_appearance' | translate"
                                >
                                    <button
                                        type="button"
                                        class="appearance-block"
                                        [class.active]="form.placement().value() === 'top'"
                                        [attr.aria-pressed]="form.placement().value() === 'top'"
                                        [attr.aria-label]="'option_animation_position_top' | translate"
                                        (click)="setPlacement('top')"
                                    >
                                        <img src="./assets/img/websites/lpc-tab-top-placement.svg" alt="" />
                                    </button>
                                    <button
                                        type="button"
                                        class="appearance-block"
                                        [class.active]="form.placement().value() === 'left'"
                                        [attr.aria-pressed]="form.placement().value() === 'left'"
                                        [attr.aria-label]="'option_animation_position_left' | translate"
                                        (click)="setPlacement('left')"
                                    >
                                        <img src="./assets/img/websites/lpc-tab-left-placement.svg" alt="" />
                                    </button>
                                    <button
                                        type="button"
                                        class="appearance-block"
                                        [class.active]="form.placement().value() === 'right'"
                                        [attr.aria-pressed]="form.placement().value() === 'right'"
                                        [attr.aria-label]="'option_animation_position_right' | translate"
                                        (click)="setPlacement('right')"
                                    >
                                        <img src="./assets/img/websites/lpc-tab-right-placement.svg" alt="" />
                                    </button>
                                </div>
                            </div>
                        </div>

                        @let tabs = form.tabs().value();
                        <div class="form-group mb-20">
                            <div class="col-xs-12">
                                <label>{{ "control_tabs" | translate }}</label>
                            </div>
                            <div
                                class="col-xs-12"
                                cdkDropList
                                [cdkDropListData]="tabs"
                                (cdkDropListDropped)="dropGroup($event)"
                            >
                                @for (tab of tabs; let i = $index; track i) {
                                    <div cdkDrag cdkDropListGroup [cdkDragData]="tab">
                                        <sp-control-handle
                                            [controlHandleBtn]="tabs.length !== 1"
                                            [controlHandleDisableDelete]="tabs.length === 1"
                                            [controlHandleMainText]="tab.title"
                                            [controlHandleDropdownActionList]="[
                                                controlHandleEvents.copy,
                                                controlHandleEvents.delete,
                                            ]"
                                            (editActionEvent)="editTab(i)"
                                            (removeActionEvent)="removeTab(i)"
                                            (copyActionEvent)="copyTab(i)"
                                        >
                                            <span cdkDragHandle></span>
                                        </sp-control-handle>
                                    </div>
                                }

                                <a
                                    class="dotted"
                                    role="button"
                                    tabindex="0"
                                    (click)="addTab()"
                                    (keydown.enter)="addTab()"
                                    (keydown.space)="$event.preventDefault(); addTab()"
                                >
                                    {{ "add" | translate }}
                                </a>
                            </div>
                        </div>

                        <sp-animation-settings-signal [field]="form.animation" />
                    </form>
                </div>
            </ng-container>
        }

        @case (settingsEnum.Appearance) {
            <web-tab-appearance-settings [form]="form" (cancelEvent)="currentSettings.set(settingsEnum.Main)" />
        }

        @case (settingsEnum.Tab) {
            <web-tab-item-settings
                [form]="form"
                [tabIndex]="editableTabIndex()"
                (cancelEvent)="currentSettings.set(settingsEnum.Main); editableTabIndex.set(null)"
            />
        }
    }
</web-settings-body>
